module.exports = __webpack_public_path__ + "static/media/medical-consult.5f350877.jpg";